import { render, staticRenderFns } from "./TitleField.vue?vue&type=template&id=4359c9d6&scoped=true&"
import script from "./TitleField.vue?vue&type=script&lang=js&"
export * from "./TitleField.vue?vue&type=script&lang=js&"
import style0 from "./TitleField.vue?vue&type=style&index=0&id=4359c9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359c9d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {VTextField})
